import { createBrowserRouter, createRoutesFromElements, defer, Route } from 'react-router-dom';

import { AuthLayout, getUserData } from './pages/authentification/AuthLayout';
import Login from './pages/authentification/Login';
import { LoginLayout } from './pages/authentification/LoginLayout';
import { ProtectedLayout } from './pages/authentification/ProtectedLayout';
import { AddCollection, addCollectionLoader } from './pages/collections/AddCollection';
import { AllCollection, collectionsLoader } from './pages/collections/AllCollection';
import { CollectionDetails, collectionDetailsLoader } from './pages/collections/CollectionDetails';
import { PutCollection, putCollectionLoader } from './pages/collections/PutCollection';
import ReloadClasses from './pages/edifice/reloadClasses/ReloadClasses';
import TransitionAnnee from './pages/edifice/transition/TransitionAnnee';
import { fileLoader, MainPage } from './pages/editor/MainPage';
import { AddEpisode } from './pages/episodes/AddEpisodes';
import LayoutEpisode from './pages/episodes/LayoutEpisode';
import AskGPT from './pages/gpt/AskGPT';
import GPTToGdoc from './pages/gpt/GptToGdoc';
import Home from './pages/home/Home';
import AddMaisonEdition from './pages/maisonEdition/AddMaisonEdition';
import ManageAccount from './pages/manage/account/ManageAccount';
import GiftCode from './pages/manage/codes/GiftCode';
import SerieCode from './pages/manage/codes/SerieCode';
import WebappCode from './pages/manage/codes/WebappCode';
import LayoutManage from './pages/manage/LayoutManage';
import { ManageCategories, manageCategoriesLoader } from './pages/manage/library/ManageCategories';
import { AddSaison } from './pages/saisons/addSaison';
import { AddSerie, addSerieLoader } from './pages/series/AddSerie';
import LayoutSerie from './pages/series/LayoutSerie';
import { PutSerie, putSerieLoader } from './pages/series/PutSerie';
import { SerieDetails, serieDetailsLoader } from './pages/series/SerieDetails';
import EmptyLayout from './pages/shared/components/EmptyLayout';
import SerieStats from './pages/stats/SerieStats';
import StickersResizer from './pages/tools/StickersResizer';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AuthLayout />} loader={() => defer({ userPromise: getUserData() })}>
      <Route element={<LoginLayout />}>
        <Route path="/login" element={<Login />} />
      </Route>

      <Route path="/" element={<ProtectedLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/gpt/gdoc" element={<GPTToGdoc />} />
        <Route path="/doc/:uidFile" element={<MainPage />} loader={fileLoader} />
        <Route path="/maison" element={<EmptyLayout />}>
          <Route path="details/:uidCollection" loader={collectionDetailsLoader} element={<CollectionDetails />} />
          <Route path="add" element={<AddMaisonEdition />} />
        </Route>
        <Route path="/collection" element={<EmptyLayout />}>
          <Route path="" loader={collectionsLoader} element={<AllCollection />} />
          <Route path=":uidCollection" loader={putCollectionLoader} element={<PutCollection />} />
          <Route path="details/:uidCollection" loader={collectionDetailsLoader} element={<CollectionDetails />} />
          <Route path="add" loader={addCollectionLoader} element={<AddCollection />} />
        </Route>

        <Route path="/serie" element={<LayoutSerie />}>
          <Route path="add" loader={addSerieLoader} element={<AddSerie />} />
          <Route path=":idSerie" loader={putSerieLoader} element={<PutSerie />} />
          <Route path=":idSerie/details" loader={serieDetailsLoader} element={<SerieDetails />} />
          <Route path="add/episode" loader={addSerieLoader} element={<AddEpisode />} />
          <Route path="add/saison" element={<AddSaison />} />
        </Route>
        <Route path="/episode/:idEpisode" element={<LayoutEpisode />}>
          <Route path="gpt" element={<AskGPT />} />
        </Route>
        <Route path="/tools" element={<EmptyLayout />}>
          <Route path="stickers" element={<StickersResizer />} />
        </Route>
        <Route path="/manage" element={<LayoutManage />}>
          <Route path="app" loader={manageCategoriesLoader} element={<ManageCategories />} />
          <Route path="account" element={<ManageAccount />} />
          <Route path="gift" element={<GiftCode />} />
          <Route path="code/webapp" element={<WebappCode />} />
          <Route path="code/serie" element={<SerieCode />} />
        </Route>
        <Route path="/edifice" element={<LayoutManage />}>
          <Route path="classes" element={<ReloadClasses />} />
          <Route path="transition" element={<TransitionAnnee />} />
        </Route>
        <Route path="/stats" element={<LayoutManage />}>
          <Route path="serie" element={<SerieStats />} />
        </Route>
      </Route>
    </Route>,
  ),
);
